import { objectToCamel } from 'ts-case-convert'
import { z } from 'zod'

const baseMeasurementGroupSchema = z.object({
  id: z.number(),
  name: z.string(),
  garment_type: z.number(),
  display_order: z.number(),
})

const baseMeasurementSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  display_order: z.number(),
})

const baseMeasurementValueSchema = z.object({
  id: z.number(),
  value: z.string().nullable(),
  description: z.string().nullable(),
  display_order: z.number(),
})

export const measurementGroupSchema = baseMeasurementGroupSchema.transform(objectToCamel)
export const measurementSchema = baseMeasurementSchema
  .extend({
    measurement_group: baseMeasurementGroupSchema,
  })
  .transform(objectToCamel)
export const measurementValueSchema = baseMeasurementValueSchema.transform(objectToCamel)

export const garmentMeasurementSchema = z
  .object({
    updated_at: z.coerce.date(),
    text: z.string().nullable(),
    measurement: baseMeasurementSchema,
    measurement_value: baseMeasurementValueSchema.nullable(),
  })
  .transform(objectToCamel)

declare global {
  namespace TrinityAPI {
    type GarmentMeasurementType = z.infer<typeof garmentMeasurementSchema>
    type MeasurementGroupType = z.infer<typeof measurementGroupSchema>
    type MeasurementType = z.infer<typeof measurementSchema>
    type MeasurementValueType = z.infer<typeof measurementValueSchema>
  }
}
